import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import AgentProfileForm from './agent-profile-form-view';

import Cons from '../../isomorphic/cons';

@inject('appStore')
@observer
export default class AgentProfileView extends Component {
    render() {
        return (
            <div className="tab-pane active detail-view">
                <div className="row">
                    {appStore.viewStore.isUserLoaded && appStore.agentProfileStore.selectedAgentProfile ? (
                        <AgentProfileForm />
                    ) : null}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/agent-profile/agent-profile-view.js